import React from 'react';
import leftArrowImg from './left-arrow-btn.png';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  buttonWrapper: {
    zIndex: 2,
    display: 'block',
    height: '40px !important',
    width: '40px !important',
    '&.slick-next::before': {
      content: ``,
      display: 'none !important',
    },
    '&.slick-prev::before': {
      content: ``,
      display: 'none !important',
    },
    [theme.breakpoints.down('sm')]: {
      height: '25px !important',
      width: '25px !important',
    },
  },
  prev: {
    left: '-50px !important',
    [theme.breakpoints.down('sm')]: {
      left: '-20px !important',
    },
  },
  next: {
    right: '-50px !important',
    [theme.breakpoints.down('sm')]: {
      right: '-20px !important',
    },
  },
}));

function SamplePrevArrow(props: any) {
  const classes = useStyles();
  const { className, ...otherProps } = props;

  return (
    <div
      {...otherProps}
      className={clsx(className, classes.buttonWrapper, classes.prev)}
    >
      <img src={leftArrowImg} style={{ maxWidth: '100%' }} alt="Left" />
    </div>
  );
}
function SampleNextArrow(props: any) {
  const classes = useStyles();
  const { className, ...otherProps } = props;

  return (
    <div
      {...otherProps}
      className={clsx(className, classes.buttonWrapper, classes.next)}
    >
      <img
        src={leftArrowImg}
        style={{ maxWidth: '100%', transform: 'rotate(180deg)' }}
        alt="Right"
      />
    </div>
  );
}

export const BaseCarousel: React.FC<any> = (props) => {
  const { children } = props;
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    adaptiveHeight: true,
  };
  return (
    <div>
      <Slider {...settings}>{children}</Slider>
    </div>
  );
};
